import { isMobile } from '../../utils/userAgent';

export const isLoggedInAsAgentInApp = async (): Promise<boolean> => {
  const CHECK_TIMEOUT = 5000;

  try {
    if (isMobile()) {
      return Promise.resolve(false);
    }
  } catch (e) {
    console.warn('Cant check if mobile');
  }

  return new Promise((resolve, reject) => {
    setTimeout(() => {
      window.removeEventListener('message', receiveMessage);
      reject(false);
    }, CHECK_TIMEOUT);

    function receiveMessage(event: any) {
      if (event.data && typeof event.data.isAgent === 'boolean') {
        window.removeEventListener('message', receiveMessage);
        resolve(event.data.isAgent);
      }
    }

    const iframe = document.querySelector(
      '#agent-check-iframe'
    ) as HTMLIFrameElement;

    if (iframe && iframe.contentWindow) {
      const { contentWindow } = iframe;
      contentWindow.postMessage('getIsAgent', '*');
      iframe.addEventListener('load', () => {
        contentWindow.postMessage('getIsAgent', '*');
      });
    } else {
      window.removeEventListener('message', receiveMessage);
      reject(false);
    }

    window.addEventListener('message', receiveMessage, false);
  });
};
